import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=4ccb4754&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=4ccb4754&prod&lang=scss&scoped=true"
import style1 from "./Organization.vue?vue&type=style&index=1&id=4ccb4754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb4754",
  null
  
)

export default component.exports